import { Select } from '@applyboard/crystal-ui';
import { useFilterField } from '~/hooks';
import { ClockOutlineIcon, SortAscendingOutlineIcon, SortDescendingOutlineIcon } from '@applyboard/ui-icons';

interface SortProps {
  showCreatedSort?: boolean;
}

export const Sort = ({ showCreatedSort = true }: SortProps) => {
  const { value, setValue } = useFilterField('sort', 'PrimaryFilter');

  return (
    <Select
      value={value}
      aria-label="Default Sort"
      placeholder="Default Sort"
      onChange={(value) => setValue(value)}
      emphasis="highlighted"
      intent="primary"
      placeholderVariant="indicator"
      appearance="styled"
    >
      <Select.Option
        label="Sort by programs (A-Z)"
        value="program.name,intakeTerm.startsOn"
        key="program.name"
        icon={SortAscendingOutlineIcon}
      />
      <Select.Option
        label="Sort by programs (Z-A)"
        value="-program.name,intakeTerm.startsOn"
        key="-program.name"
        icon={SortDescendingOutlineIcon}
      />
      {showCreatedSort && (
        <Select.Option
          label="Sort by created (Most recent)"
          value="-createdAt,program.name,intakeTerm.startsOn,campus.name"
          key="-createdAt"
          icon={ClockOutlineIcon}
        />
      )}
    </Select>
  );
};
